import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Switch,
  FormControlLabel,
  MenuItem,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { OrganisationFormData } from '../../../../types/organization';

const PlanTypeOptions = [
  { key: 'STANDARD', value: 'standard', label: 'Standard Plan' },
  { key: 'ECONOMY', value: 'economy', label: 'Economy Plan' },
];

interface SubscriptionFormProps {
  data: OrganisationFormData;
  onUpdate: (section: string, data: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export default function SubscriptionForm({
  data,
  onUpdate,
  onNext,
  onBack,
}: SubscriptionFormProps) {
  const { control, handleSubmit, watch } = useForm({
    defaultValues: data,
  });

  const isBookingEnabled = watch('isBookingEnabled');
  const onSubmit = (formData: OrganisationFormData) => {
    onUpdate('planType', formData.planType);
    onUpdate('isBookingEnabled', formData.isBookingEnabled);
    onUpdate('resourceProfessional', formData.resourceProfessional);
    onUpdate('bookingDescription', formData.bookingDescription);
    onUpdate('dealerPromo', formData.dealerPromo);
    onNext();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Subscription Details
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Controller
            name="isBookingEnabled"
            control={control}
            render={({ field: { value, onChange } }) => (
              <FormControlLabel
                control={<Switch checked={value} onChange={e => onChange(e.target.checked)} />}
                label="Enable Online Booking"
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="resourceProfessional"
            control={control}
            rules={{ required: 'Resource profession is required' }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label="Resource Profession"
                fullWidth
                error={!!error}
                helperText={error?.message}
                placeholder="e.g., Doctors, Hairdressers, Therapists"
              />
            )}
          />
        </Grid>

        {isBookingEnabled && (
          <Grid item xs={12}>
            <Controller
              name="bookingDescription"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Booking Description"
                  fullWidth
                  multiline
                  rows={3}
                  placeholder="Describe your booking service"
                />
              )}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <Controller
            name="dealerPromo"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Dealer Promo Code"
                fullWidth
                placeholder="Enter dealer promo code (optional)"
                helperText="Links this organization to a dealer"
              />
            )}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button onClick={onBack}>Back</Button>
        <Button type="submit" variant="contained" disableElevation sx={{ minWidth: 120 }}>
          Next
        </Button>
      </Box>
    </form>
  );
}
